module.exports = __webpack_public_path__ + "img/professioneel-logo-personal-trainer-coaching-raise-the-bar-oudenaarde-nutrition-coach-2.2b2839b7.jpg";